import { useAtomValue, useSetAtom } from 'jotai';
import { observer } from 'mobx-react-lite';
import { useCallback, useEffect } from 'react';

import { useAnalytics } from '@features/Analytics';
import { stripeWasPaymentTriedAtom } from '@features/Stripe/atoms';
import { FormattedMessage } from '@features/intl';
import { Image } from 'src/components/common/Image';
import AlertWithCloseButton from 'src/components/common/modal/alert-with-close-button/alert-with-close-button';

import styles from './one-time-offer-modal.module.scss';

export const StripeOneTimeOffer = observer(() => {
  const { trackGoogleEvent } = useAnalytics();
  const { oneTimeOfferShow, wasTried } = useAtomValue(
    stripeWasPaymentTriedAtom,
  );

  const setStripeWasPaymentTried = useSetAtom(stripeWasPaymentTriedAtom);

  const handleHide = useCallback(() => {
    trackGoogleEvent({
      eventName: 'offer_onetime_skipped',
    });

    // @ts-ignore
    setStripeWasPaymentTried((previous) => ({
      ...previous,
      oneTimeOfferShow: false,
      wasTried: true,
    }));
  }, [setStripeWasPaymentTried, trackGoogleEvent]);

  useEffect(() => {
    if (oneTimeOfferShow) {
      trackGoogleEvent({
        eventName: 'offer_onetime_opened',
      });
    }
  }, [oneTimeOfferShow, trackGoogleEvent]);
  return (
    <AlertWithCloseButton
      modalContentClassName={styles.modal}
      show={oneTimeOfferShow && !wasTried}
      canClose
      onHide={handleHide}
      titleId="Onboarding.Did.You.Know.Title"
      closeButtonId="Onboarding.Did.You.Know.Button"
      description={
        <p className={styles.description}>
          <FormattedMessage
            defaultMessage="69% of our users say they got results after the first month of using their personal program 🔥"
            id="Onboarding.Did.You.Know.Subtitle"
          />
        </p>
      }
    >
      <Image width={327} height={216} src="table.webp" alt="table" />
      <p className={styles.footerDescription}>
        <FormattedMessage
          defaultMessage="We want you to achieve your goals! That’s why {mark}"
          id="Onboarding.Did.You.Know.Text"
          values={{
            mark: (
              <strong>
                <FormattedMessage
                  defaultMessage="we offer a unique discount for your personal program"
                  id="Onboarding.Did.You.Know.Text.Mark"
                />
              </strong>
            ),
          }}
        />
      </p>
    </AlertWithCloseButton>
  );
});
